import React from 'react';
import Icon from 'common/components/elements/icons';
import PropTypes from 'prop-types';

const BenefitCard = ({
   name,
   isActive,
}) => {
   let iconName = 'done';
   let iconColor = 'success';
   if(isActive){
      iconName = 'close';
      iconColor = 'error';
   }
   return (
      <div
         className='flex mr-[10px] mb-1 items-center'
      >
         <div
            className={ `w-4 h-4 flex items-center justify-center rounded-full mr-2 bg-${ iconColor }-12 dark:bg-${ iconColor }-dark-12` }>
            <Icon name={ iconName } style={ {  fontSize: '10px' } } color={ iconColor } darkColor={ `${ iconColor }-dark` } />
         </div>
         <span className='text-secondary text-sm leading-[20px] font-medium dark:text-secondary-dark '>{name}</span>
      </div>
   )
};

BenefitCard.propTypes = {
   name: PropTypes.string,
   isActive: PropTypes.bool,
};

export default BenefitCard;
